var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"v-textbox"},[_c('input',{ref:"textbox",class:[
      'v-textbox__input',
      !_vm.isValid ? 'v-textbox__input__not-valid' : ''
    ],attrs:{"type":"text","name":_vm.name,"required":_vm.required,"placeholder":_vm.targetPlaceholder},on:{"input":function($event){return _vm.onInputEventHandler()}}})])}
var staticRenderFns = []

export { render, staticRenderFns }